import React from 'react';

import { Container, Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import styled from '../../styled';
import { colorsPalette, LARGE_MARGIN_PX, SMALL_MARGIN_PX } from '../../theme';

// todo: make redirect with code 404 to this page instead of returning it manually like
//  <RouteWithCode code={404}>
//    <NotFoundPage />
//  </RouteWithCode>
const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <Container data-testid="notFoundPage">
      <Wrapper>
        <Typography variant="h1">{t('page.notFound.error')}</Typography>
        <Typography variant="h3">{t('page.notFound.errorTitle')}</Typography>
        <Typography align="center">{t('page.notFound.errorDescription')}</Typography>
      </Wrapper>
    </Container>
  );
};

export default NotFoundPage;

const Wrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 300px);
  color: ${colorsPalette.white};
  ${({ theme }) => theme.breakpoints.up('md')} {
    min-height: calc(100vh - 250px);
  }
  & h1 {
    color: ${alpha(colorsPalette.white, 0.5)};
    ${({ theme }) => theme.breakpoints.up('md')} {
      font-size: 50px;
    }
  }
  & h3 {
    margin: ${LARGE_MARGIN_PX} 0 ${SMALL_MARGIN_PX};
  }
`;
